import { Permiso, PermisoForm } from '@models/.';
import { transformPermissionDetailForm } from '..';

export function transformToData(permission: Permiso | null): Permiso | null {
  if (!permission) return null;
  
  return {
    ...permission,
  };
}

export function transformToForm(permission: Permiso): PermisoForm | null {
  if (!permission) return null;
  
  const {
    id,
    ver: view,
    crear: create,
    modificar: modify,
    eliminar: deleteElement,
    fechaCreacion: creationDate,
    fechaActualizacion: updateDate,
    permiso: permissionDetail,
  } = permission
  
  return {
    id,
    view,
    create,
    modify,
    delete: deleteElement,
    creationDate,
    updateDate,
    permission: transformPermissionDetailForm(permissionDetail),
  };
}